// extracted by mini-css-extract-plugin
export default {"component":"table_component__DT800","header":"table_header__Zeu8F","rank":"table_rank__E64VY","reward":"table_reward__vHSOp","list":"table_list__ZiIpx"};